/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface TaskRecheckResult { 
    resolved: boolean;
    reason: string;
}
export const TaskRecheckResult_resolved_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskRecheckResult_reason_Validators: ValidatorFn[] =
    [  Validators.required, ];


